import { Box } from "@material-ui/core";

export const ExperimentContainer = ({ children }) => <Box px={32}>{children}</Box>